import type { PropsWithChildren } from 'react';
import type React from 'react';

import { PetitionEditBannerStateContextProvider } from './context';
import { useBannerState } from './hook';

export const PetitionEditBannerStateProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const bannerState = useBannerState();

	return <PetitionEditBannerStateContextProvider {...bannerState}>{children}</PetitionEditBannerStateContextProvider>;
};
